import {
    FETCH_PROVIDERS_SUCCESS,
    FETCH_PROVIDERS_FAILURE,
  } from "./actionTypes";
  
  const initialState = {
    providers: [],
    error: null,
  };
  
  const providers = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PROVIDERS_SUCCESS:
        return {
          ...state,
          providers: action.payload,
          error: null,
        };
      case FETCH_PROVIDERS_FAILURE:
        return {
          ...state,
          providers: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default providers;